(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.QuidTopics = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, DataSourceFilterGroupIds) {
        return {

            channelName: 'QuidTopics',

            storageDimensions: [
                'listeningQueryId'
            ],

            availableDimensions: [
                'themeId'
            ],

            fields: {
                listeningQueryId: {
                    dataType: dataType.STRING
                },
                listeningQueryName: {
                    dataType: dataType.STRING
                },

                // fields from the Quid theme (if any)
                themeId: {
                    dataType: dataType.STRING
                },
                themeName: {
                    dataType: dataType.STRING
                },

                themeNamesDisplay: {
                    dataType: dataType.STRING
                },

                // fields from the Quid theme definition (if any)
                themeSentiments: {
                    dataType: dataType.STRING
                },

                // fields from the Quid topic
                topicId: {
                    dataType: dataType.STRING
                },
                topicName: {
                    dataType: dataType.STRING
                },

                // fields from the Quid topic definition
                topicDescription: {
                    dataType: dataType.STRING
                },
                topicTimeInterval: {
                    dataType: dataType.STRING
                },
                topicTimePeriod: {
                    dataType: dataType.STRING
                },
                topicLanguageFilter: {
                    dataType: dataType.STRING
                },
                topicSentimentFocus: {
                    dataType: dataType.STRING
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.listening,
                DataSourceFilterGroupIds.timezone
            ]
        };
    }
})();
